// src/components/MainLayout.jsx
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";

export default function MainLayout() {
  const { pathname } = useLocation();

  const pageTitles = {
    // Core
    "/dashboard": "Dashboard",
    "/users": "Users",
    "/revenue": "Revenue",
    "/feedback": "System Feedback",
    "/logs": "Activity Logs",
    "/profile": "Profile",
    "/settings": "Settings",

    // (Legacy direct links, keep if you still navigate to them anywhere)
    "/drivers": "Drivers",
    "/passengers": "Passengers",

    // Finance
    "/finance/wallet": "Finance – Wallet",

    // Management
    "/master-management": "Master Management",
    "/master-management/role-management": "Role Management",
    "/master-management/notifications": "Notifications",
    "/master-management/points-management": "Points Management",
    "/master-management/tax-management": "Tax Management",
    "/master-management/offers-and-rewards": "Offers Management",
    "/master-management/platform-fee-management": "Platform Fee Management",

    // Services: Transport
    "/services/transport/driver-approvals": "Transport Service",
    "/services/transport/drivers": "Transport – Drivers",
    "/services/transport/passengers": "Transport – Passengers",
    "/services/transport/rides": "Transport – Rides",
    "/services/transport/ride-types": "Transport – Ride Types",

    // Services: Food
    "/services/food/restaurants": "Food – Restaurants",
    "/services/food/orders": "Food – Orders",
    "/services/food/food-types": "Food – Cuisine Types",

    // Services: Mart
    "/services/mart/products": "Mart – Products",
    "/services/mart/orders": "Mart – Orders",
    "/services/mart/product-types": "Mart – Product Business Types",

    // Services: Events & Entertainment
    "/services/events/bookings":   "Entertainment – Bookings",
    "/services/events/revenue":    "Entertainment – Revenue",
    "/services/events/banners":    "Entertainment – Banners",
    "/services/events/organizers": "Entertainment – Organizers",
    "/services/events":            "Entertainment – Events",

    // Services: Dining Out
    "/services/dining/reservations":     "Dining Out – Reservations",
    "/services/dining/restaurant-types": "Dining Out – Restaurant Types",

    // Services: Hotel
    "/services/hotel/bookings":    "Hotel – Bookings",
    "/services/hotel/room-types":  "Hotel – Room Types",
  };

  const title = (() => {
    // normalise path & keys (lowercase + no trailing slash)
    const normPath = (pathname || "/").toLowerCase().replace(/\/+$/, "") || "/";

    // 1) exact match, case-insensitive
    for (const [key, label] of Object.entries(pageTitles)) {
      const normKey = key.toLowerCase().replace(/\/+$/, "") || "/";
      if (normPath === normKey) return label;
    }

    // 2) longest prefix match
    let bestTitle = null;
    let bestLen = -1;
    for (const [key, label] of Object.entries(pageTitles)) {
      const normKey = key.toLowerCase().replace(/\/+$/, "");
      if (normPath.startsWith(normKey) && normKey.length > bestLen) {
        bestLen = normKey.length;
        bestTitle = label;
      }
    }
    if (bestTitle) return bestTitle;

    // 3) last-resort special for any feedback-related path
    if (normPath.includes("feedback")) return "System Feedback";

    // 4) default fallback
    return "སྟབས་བདེ Admin";
  })();

  return (
    <div className="wrapper d-flex flex-wrap">
      <Sidebar />

      <div className="main-content flex-grow-1 p-4 d-flex flex-column">
        <TopBar title={title} />
        <Outlet />
      </div>
    </div>
  );
}
